import classNames from "classnames";

interface IAvisTitleAndSubtitleProps {
  title: string | undefined;
  subTitle?: string;
  className?: string;
}
export function AvisTitleAndSubtitle(
  props: Readonly<IAvisTitleAndSubtitleProps>,
) {
  const { title, subTitle, className } = props;

  const classNameSection = classNames("title-and-subtitle", className);
  return (
    <div className={classNameSection}>
      <div className="title">{title}</div>
      {subTitle && <div className="subtitle">{subTitle}</div>}
    </div>
  );
}
